import type { DestinationState } from 'ts/types/destination.types';
import { DestinationActionType } from 'redux/actions/destinationActions';
import {
  SET_DESTINATION_QUALIFIERS,
  SET_TOWING_SERVICE_ID,
  UPDATE_DESTINATION_ADDRESS,
  SET_DESTINATION_SELECTED_OPTION,
  TOGGLE_DESTINATION_ALERT,
} from 'redux/actions/types';

const initialState: DestinationState = {
  choices: [],
};

function destinationReducer(
  state = initialState,
  action: DestinationActionType,
): DestinationState {
  switch (action.type) {
    case SET_DESTINATION_QUALIFIERS:
      return { ...state, ...action.payload };
    case SET_TOWING_SERVICE_ID:
      return { ...state, ...action.payload };
    case UPDATE_DESTINATION_ADDRESS:
      return { ...state, ...action.payload };
    case SET_DESTINATION_SELECTED_OPTION:
      return { ...state, ...action.payload };
    case TOGGLE_DESTINATION_ALERT:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export default destinationReducer;
